Object.defineProperty(exports, "__esModule", {
  value: true
});

var makeRemoteExecutableSchema_1 = require("./makeRemoteExecutableSchema");

exports.makeRemoteExecutableSchema = makeRemoteExecutableSchema_1.default;
exports.defaultCreateRemoteResolver = makeRemoteExecutableSchema_1.createResolver;

var introspectSchema_1 = require("./introspectSchema");

exports.introspectSchema = introspectSchema_1.default;

var mergeSchemas_1 = require("./mergeSchemas");

exports.mergeSchemas = mergeSchemas_1.default;

var delegateToSchema_1 = require("./delegateToSchema");

exports.delegateToSchema = delegateToSchema_1.default;

var defaultMergedResolver_1 = require("./defaultMergedResolver");

exports.defaultMergedResolver = defaultMergedResolver_1.default;